import Header from '../../Component/Header';
import "../../styles/scope.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../../Component/DatePicker"
import ReactPaginate from "react-paginate";
import ScopePopup from './ScopePopup';
import axiosInstance from '../../axiosInstance';
import { ToastContainer, toast } from "react-toastify";
import '../../styles/ScopePopup.css';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { useGlobal } from '../../GlobalContext';

const ScopeGrid = () => {

  const { rolePermissionList } = useGlobal();

  // True when the role has the given permission for the named menu.
  const checkPermission = (menuName, permission) =>
    rolePermissionList.some((element) => element.name === menuName && element[permission] === true);

  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Fetch API Function
  const fetchScopes = async (term = '') => {
    try {
      const url = term
        ? `/costsolution/scope?search=${term}&limit=${limit}&skip=${skip}`
        : `/costsolution/scope?limit=${limit}&skip=${skip}`;

      const response = await axiosInstance.get(url);

      if (Array.isArray(response.data.scopes)) {
        setTableData(response.data.scopes);
        setTotal(response.data.totalCount || 0);
        setTotalPages(Math.ceil((response.data.totalCount || 0) / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      setError(error.message);
      toast.error("Failed to fetch scopes");
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchScopes(searchTerm);
  }, [skip, limit, reload]);

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchScopes(term);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleAddNewClick = (row) => {
    setEditData(row ? { id: row.id } : null);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };

  const handleDeleteRow = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      await axiosInstance.delete(`/costsolution/scope/delete/${deleteId}`);
      toast.success("Scope deleted successfully!");
      setTableData(prevData => prevData.filter(row => row.id !== deleteId));
      setTotal(prevTotal => prevTotal - 1);
      fetchScopes()
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete scope");
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  return (
    <>
      <Header onSearch={handleSearch} />

      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Scope ({total})</h3>
          </div>
          <div className="right-header">
            {checkPermission("Scope", "create_permission") && (
              <button id="addNewBtn" onClick={() => handleAddNewClick()}>
                Add New
              </button>
            )}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
              </th>
              <th>S.No</th>
              <th>Code</th>
              <th>Name</th>
              <th></th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <tr key={row.id}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{skip + index + 1}</td>
                  <td>{row.code}</td>
                  <td>{row.name}</td>
                  <td></td>
                  <td>{row.modifieddate}</td>
                  <td>
                    <div className="actions">
                      {checkPermission("Scope", "edit_permission") && (
                        <span className="edit-icon">
                          <img
                            src={Vector}
                            alt="Edit Icon"
                            width="20"
                            height="20"
                            onClick={() => handleAddNewClick(row)}
                          />
                        </span>
                      )}

                      {checkPermission("Scope", "delete_permission") && (
                        <span
                          className="delete-icon"
                          onClick={() => handleDeleteRow(row.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={Delete} alt="Delete Icon" width="40" height="40" />
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                {searchTerm && tableData.length === 0 && (
                  <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                    No Scope area found matching "{searchTerm}"
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>

      <CommonFooter />

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <ScopePopup closePopup={closePopup} editData={editData} triggerReload={() => setReload(prev => !prev)} />
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this scope?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default ScopeGrid;